// extracted by css-extract-rspack-plugin
export default {"badge":"O7n5W6JunpUg9fMF","content":"yLLTqcrsF3jROA8o"};